import React, { FC, memo, useMemo } from 'react';
import { StatusTip } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import { useIntl, getLocale } from 'umi';

import {
  BenchmarkSegment,
  BenchmarkSecondSegment,
} from '../../_config/constant';
const { LoadingTip } = StatusTip;
import './index.scss';
interface SummeryProps {
  summary: any;
  segmentMain: string;
  segmentSub: string;
  loading: boolean;
  isPoeGame: boolean;
}

const Summery: FC<SummeryProps> = (props) => {
  const { segmentMain, segmentSub, summary, loading, isPoeGame } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const {
    country_info = [],
    country_cn_info = [],
    revenue_trends = [],
    sales_trend = [],
    gas_ratio = {},
  } = summary;

  const segmentInfo = useMemo(() => {
    const main = BenchmarkSegment.find((item) => item.value === segmentMain);
    const sub = BenchmarkSecondSegment.find(
      (item) => item.value === segmentSub,
    );
    return {
      title: formatMessage({id:main?.value === 'customize' && isPoeGame ? 'dbi_benchmark_poe_like': main?.text }),
      subTitle: sub?.text || '',
    };
  }, [segmentMain, segmentSub, locale]);

  const renderTargetEntityType = (pc: string[], console: string[]) => {
    if (!pc?.length && !console?.length) {
      if(locale === 'zh-CN'){
        return `${segmentInfo?.title}游戏的GaaS数据可能丢失或不可用`
       }
      return `GaaS data of ${segmentInfo?.title} games may be missing/unavailable.`;
    }
    if (!pc?.length) {
      if(locale === 'zh-CN'){
       return 'PC端的GaaS数据可能丢失或不可用'
      }
      return '(GaaS data of PC may be missing/unavailable)';
    }

    if (!console?.length) {
      if(locale === 'zh-CN'){
        return '主机端的GaaS数据可能丢失或不可用'
       }
      return '(GaaS data of Console may be missing/unavailable)';
    }
  };

  const renderCountryInfo = (info: string[]) => {
    if (!info) return null;

    if (info?.length === 1) {
      if(locale === 'zh-CN'){
        return <>销量主要分布在{' '}
        <span className="highlight">{country_cn_info[0]}</span>{' '}等地区。
       </>
      }
      return (
        <>
          Sales are mainly distributed in regions such as the{' '}
          <span className="highlight">{country_info[0]}</span>.
        </>
      );
    }

    if (info?.length === 2) {
      if(locale === 'zh-CN'){
        return <>销售主要分布在{' '}
        <span className="highlight">{country_cn_info[0]}</span>,{' '}和{' '}
        <span className="highlight">{country_cn_info[1]}</span>{' '}
        等地区。</>
      }
      return (
        <>
          Sales are mainly distributed in regions such as the{' '}
          <span className="highlight">{country_info[0]}</span> and{' '}
          <span className="highlight">{country_info[1]}</span>.
        </>
      );
    }

    if (info?.length === 3) {
      if(locale === 'zh-CN'){
        return <>销售主要分布在{' '}
        <span className="highlight">{country_cn_info[0]}</span>,{' '}
        <span className="highlight">{country_cn_info[1]}</span>{' '}和{' '}
        <span className="highlight">{country_cn_info[2]}</span>{' '}等地区。</>
      }
      return (
        <>
          Sales are mainly distributed in regions such as the{' '}
          <span className="highlight">{country_info[0]}</span>,{' '}
          <span className="highlight">{country_info[1]}</span>, and{' '}
          <span className="highlight">{country_info[2]}</span>.
        </>
      );
    }
  };


  const subTitle = useMemo(()=> {
    if(locale === 'zh-CN'){
      return <>对于五年内的<span className="highlight">{segmentInfo?.title}</span>类游戏 :</>
    }

    return <>For <span className="highlight">{segmentInfo?.title} games</span>,
    within a five-year period:</>
  }, [locale, segmentInfo])


  const revenueTrend = useMemo(()=> {
    if(!revenue_trends) return ''
    if(locale === 'zh-CN'){
      return <>Y1:Y2:Y3:Y4:Y5 的相对收入趋势为  <span className="highlight">{revenue_trends[0]}</span> 。</>
    }
    return <>
      The relative revenue trend of Y1:Y2:Y3:Y4:Y5 is{' '}
      <span className="highlight">{revenue_trends[0]}</span>.{' '}
    </>
  }, [locale, revenue_trends])


  const revenueRatio = useMemo(()=> {
    if(!revenue_trends) return ''
    if(locale === 'zh-CN'){
      return <>PC端和主机端的比例为 <span className="highlight">{revenue_trends[1]}</span>  。</>
    }
    return <>
      The PC and console ratio is{' '}
      <span className="highlight">{revenue_trends[1]}</span>.
    </>
  }, [locale, revenue_trends])

  const salesTrend = useMemo(()=> {
    if(!sales_trend) return ''
    if(locale === 'zh-CN'){
      return <>Y1:Y2:Y3:Y4:Y5 的相对销售趋势为 <span className="highlight">{sales_trend[0]}</span> 。</>
    }
    return <>
      The relative sales trend of Y1:Y2:Y3:Y4:Y5 is{' '}
      <span className="highlight">{sales_trend[0]}</span>.{' '}
    </>
  }, [locale, sales_trend])


  const salesRatio = useMemo(()=> {
    if(!sales_trend) return ''
    if(locale === 'zh-CN'){
      return <>PC端和主机端的比例为 <span className="highlight">{sales_trend[1]}</span> 。</>
    }
    return <>
        The PC and console ratio is{' '}
        <span className="highlight">{sales_trend[1]}</span>.
      </>
  }, [locale, sales_trend])

  const gasRatio = useMemo(()=> {
    if(locale === 'zh-CN'){
       return <>PC端的 GaaS 比例从{' '} 
       <span className="highlight">{gas_ratio?.pc?.[1] || '0%'}</span>{' '}
       逐步{gas_ratio?.pc?.[0] === 'increases'? '上升': '减少'}到{' '}
       <span className="highlight">{gas_ratio?.pc?.[2] || '0%'}</span>
       ，主机端的 GaaS 比例从{' '}  
       <span className="highlight">{gas_ratio?.console?.[1] || '0%'}</span>{' '} 
        {gas_ratio?.console?.[0] === 'increases'? '上升': '减少'}到{' '} 
       <span className="highlight">{gas_ratio?.console?.[2] || '0%'}</span>{' '}。</>
    }
    return <>
      The GaaS ratio gradually{' '}
      <span className="highlight">
        {gas_ratio?.pc?.[0] || 'increases'}
      </span>{' '}
      from{' '}
      <span className="highlight">{gas_ratio?.pc?.[1] || '0%'}</span>{' '}
      to{' '}
      <span className="highlight">{gas_ratio?.pc?.[2] || '0%'}</span>{' '}
      for PC, and{' '}
      <span className="highlight">
        {gas_ratio?.console?.[0] || 'increases'}
      </span>{' '}
      from{' '}
      <span className="highlight">
        {gas_ratio?.console?.[1] || '0%'}
      </span>{' '}
      to{' '}
      <span className="highlight">
        {gas_ratio?.console?.[2] || '0%'}
      </span>{' '}
      for console.{' '}
    </>
  }, [locale, gas_ratio])

  const noDataRevenue = useMemo(()=> {
    if(locale === 'zh-CN'){
      return `${segmentInfo?.title}游戏的收入数据可能丢失或不可用`
    }
    return `Revenue data of ${segmentInfo?.title} games may be missing/unavailable.`
  }, [locale, revenue_trends])

  const noDataPlayer =useMemo(()=> {
    if(locale === 'zh-CN'){
      return `${segmentInfo?.title}游戏的玩家数据可能丢失或不可用`
    }
     return `PC players data of ${segmentInfo?.title} games may be missing/unavailable.`
  }, [locale, country_info])

  return (
    <CardSlotV2
      iconList={[]}
      title={formatMessage({id: 'dbi_benchmark_summary'})}
      className="dbi-benchmark-summary"
    >
      {loading ? (
        <div className="dbi-benchmark-summary-loading">
          <LoadingTip />
        </div>
      ) : (
        <>
          <div className="summary-sub-title">
            { subTitle }
          </div>
          <div className="summary-content">
            {revenue_trends?.length > 0 ? (
              <>
                {!!revenue_trends[0] && revenueTrend}
                {!!revenue_trends[1] && revenueRatio}
              </>
            ) : (
              `Revenue data of ${segmentInfo?.title} games may be missing/unavailable.`
            )}
          </div>
          <div className="summary-content">
            {sales_trend?.length > 0 ? (
              <>
                {!!sales_trend[0] && salesTrend }
                {!!sales_trend[1] && salesRatio}
              </>
            ) : noDataRevenue }
          </div>
          <div className="summary-content">
            {!gas_ratio?.console?.length && !gas_ratio?.pc?.length ? null : gasRatio}
            {renderTargetEntityType(gas_ratio?.pc, gas_ratio?.console)}
          </div>
          {country_info && !!country_info.length ? (
            <div className="summary-content">
              {renderCountryInfo(country_info)}
            </div>
          ) : (
            <div className="summary-content">{noDataPlayer}</div>
          )}
        </>
      )}
    </CardSlotV2>
  );
};

Summery.displayName = 'Summery';

export default memo(Summery);
